module.exports = __webpack_public_path__ + "static/media/footer-location.17324bb8.svg";